import { render, staticRenderFns } from "./Notenstruktur.vue?vue&type=template&id=6f44dbf8"
import script from "./Notenstruktur.vue?vue&type=script&lang=js"
export * from "./Notenstruktur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports